module.exports = __webpack_public_path__ + "static/media/ard-alpha.452ee9c0.svg";